import React, {useContext} from "react";
import PropTypes from "prop-types";
import {AIcon} from "@cisco-sbg-ui/magna-react";
import classNames from "classnames";
import {t} from "i18next";
import {useSelector} from "react-redux";
import {InvestigationDetailContext} from "contexts/InvestigationDetailContext";
import {RelationsGraphContext} from "contexts/RelationsGraphContext";
import {selectInvestigationGraphLoading} from "store/selectors/investigationSelectors";
import GraphToolbarItem from "./GraphToolbarItem";
import css from "./GraphToolbar.module.scss";

const GraphToolbar = ({handMode, setHandMode, handleFit, handleZoom}) => {
  const isLoading = useSelector(selectInvestigationGraphLoading);

  const {isFullscreen, setIsFullscreen} = useContext(
    InvestigationDetailContext
  );
  const {
    graphNodeCount,
    combine,
    layout,
    setOpenCombos,
    setCombine,
    setLayout
  } = useContext(RelationsGraphContext);

  const refreshGraph = (e) => {
    setOpenCombos({});
    setCombine({...combine});
    setLayout({...layout});
  };

  return (
    <div className={css.graphToolbar}>
      <GraphToolbarItem
        title="Full screen"
        icon={<i className="ph-corners-in"></i>}
        onClick={() => setIsFullscreen(!isFullscreen)}
        disabled={isLoading || !graphNodeCount}
      />
      <GraphToolbarItem
        icon={<AIcon>arrows-in</AIcon>}
        title={"Fit to window"}
        onClick={() => handleFit("all")}
        disabled={isLoading || !graphNodeCount}
      />
      <GraphToolbarItem
        title="Zoom in"
        icon={<AIcon>plus</AIcon>}
        onClick={() => handleZoom("in")}
        disabled={isLoading || !graphNodeCount}
      />
      <GraphToolbarItem
        title="Zoom out"
        icon={<AIcon>minus</AIcon>}
        onClick={() => handleZoom("out")}
        disabled={isLoading || !graphNodeCount}
      />
      <GraphToolbarItem
        title="Mode"
        icon={<i className={`ph-${handMode ? "hand" : "cursor"}`}></i>}
        onClick={() => setHandMode(!handMode)}
        disabled={isLoading || !graphNodeCount}
      />
      <GraphToolbarItem
        title="Reset Graph"
        icon={<AIcon>refresh</AIcon>}
        onClick={refreshGraph}
        disabled={isLoading || !graphNodeCount}
      />

      {/**
       * @todo i18next
       */}
      {graphNodeCount > 0 && (
        <span className="mx-2">
          <strong>
            {t("investigationDetail.toolbar.nodeCount", {
              count: graphNodeCount
            })}
          </strong>
        </span>
      )}
    </div>
  );
};

GraphToolbar.propTypes = {
  handMode: PropTypes.bool,
  setHandMode: PropTypes.func,
  handleFit: PropTypes.func,
  handleZoom: PropTypes.func
};

export default GraphToolbar;
